import { AxiosResponse } from 'axios';
import api from '~/services/api';

class ProductPhotosService {
  getListPicturesProducts({ ...filters }: any, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/product/pictures', {
      params: {
        ...filters
      },
      ...opts
    });
  }

  getListPicturesProductsCount({ ...filters }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/product/pictures?isCount=true', {
      params: {
        ...filters
      },
      ...opts
    });
  }

  getPictureById(id: string, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get(`/product/pictures/${id}`, {
      ...opts
    });
  }

  savePictures({ ...data }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.put('/product/pictures', data, {
      ...opts
    });
  }

  uploadPicture(files): Promise<AxiosResponse<any[] | null>> {
    const formData = new FormData();
    formData.append('files', files);

    return api.put('/product/pictures/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  getPicturesUrls(pictureUrl: string): Promise<AxiosResponse<any[] | null>> {
    return api.get('/product/pictures', {
      params: {
        pictureUrl
      }
    });
  }

  deletePictures({ ...data }): Promise<AxiosResponse<any[] | null>> {
    return api.delete('/product/pictures', {
      data
    });
  }
}

export default new ProductPhotosService();
